import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import { Toaster } from '@/components/ui/sonner';
import Layout from '@/components/Layout';
import LoginPage from '@/pages/LoginPage';
import DashboardPage from '@/pages/DashboardPage';
import CampaignsPage from '@/pages/CampaignsPage';
import CampaignDetailPage from '@/pages/CampaignDetailPage';
import ImportsPage from '@/pages/ImportsPage';
import ProspectsPage from '@/pages/ProspectsPage';
import CallModePage from '@/pages/CallModePage';
import ReportingPage from '@/pages/ReportingPage';
import UsersPage from '@/pages/UsersPage';
import SettingsPage from '@/pages/SettingsPage';
import LogsPage from '@/pages/LogsPage';
import MapPage from '@/pages/MapPage';
import SuggestionsPage from '@/pages/SuggestionsPage';
import AutomationsPage from '@/pages/AutomationsPage';
import HelpPage from '@/pages/HelpPage';
import MonEspacePage from '@/pages/MonEspacePage';
import OpportunitiesPage from '@/pages/OpportunitiesPage';
import ActivitiesPage from '@/pages/ActivitiesPage';
import RdvPage from '@/pages/RdvPage';
import '@/App.css';

function ProtectedRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="w-8 h-8 rounded-lg bg-[#0055FF] flex items-center justify-center mx-auto mb-3 animate-pulse">
          <span className="text-white text-xs font-bold">P</span>
        </div>
        <p className="text-sm text-[#71717A]">Chargement...</p>
      </div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  return <Outlet />;
}

function AdminRoute() {
  const { user } = useAuth();
  if (user?.role !== 'admin' && user?.role !== 'super_admin') return <Navigate to="/" replace />;
  return <Outlet />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/reset-password" element={<LoginPage />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/campaigns" element={<CampaignsPage />} />
              <Route path="/campaigns/:id" element={<CampaignDetailPage />} />
              <Route path="/imports" element={<ImportsPage />} />
              <Route path="/prospects" element={<ProspectsPage />} />
              <Route path="/carte" element={<MapPage />} />
              <Route path="/suggestions" element={<SuggestionsPage />} />
              <Route path="/automatisations" element={<AutomationsPage />} />
              <Route path="/call-mode" element={<CallModePage />} />
              <Route path="/reporting" element={<ReportingPage />} />
              <Route element={<AdminRoute />}>
                <Route path="/users" element={<UsersPage />} />
                <Route path="/activities" element={<ActivitiesPage />} />
              </Route>
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/mon-espace" element={<MonEspacePage />} />
              <Route path="/opportunites" element={<OpportunitiesPage />} />
              <Route path="/rdv" element={<RdvPage />} />
              <Route path="/aide" element={<HelpPage />} />
              <Route path="/logs" element={<LogsPage />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
